/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ProgramSummary = core.serialization.object({
    totalRuleCount: core.serialization.number(),
    addedRuleCount: core.serialization.number(),
    deletedRuleCount: core.serialization.number(),
});
